const { isUndefined } = require('lodash');
const axios = require('axios');

const HEADERS = {
        'X-Inscene-Client-Id': 'web-code',
    },
    CONFIG = {};

function getHeaders() {
    return HEADERS;
}

function setAuthToken(token) {
    HEADERS['X-Inscene-Requester-Id'] = token;
    HEADERS.Authorization = token ? 'Bearer ' + token : null;
    resetAxiosInstance();
}

function setCSRFToken(token) {
    HEADERS['X-CSRFToken'] = token;
    resetAxiosInstance();
}

function getCSRFToken() {
    return HEADERS['X-CSRFToken'];
}

function setClientId(clientId) {
    HEADERS['X-Inscene-Client-Id'] = clientId;
    resetAxiosInstance();
}

function setBaseURL(url) {
    CONFIG.apiURL = url;
    resetAxiosInstance();
}

function setSocketURL(url) {
    CONFIG.socketURL = url;
}

function getSocketURL() {
    return CONFIG.socketURL ?? CONFIG.apiURL;
}

const OPTIONS = {};
function setOptions(moreOptions) {
    Object.assign(OPTIONS, moreOptions);
    resetAxiosInstance();
}

let axiosInstance = null;
function getAxiosInstance(params) {
    if (!axiosInstance) {
        axiosInstance = axios.create({
            headers: HEADERS,
            baseURL: CONFIG.apiURL,
            ...OPTIONS,
        });
    }

    if (params) {
        return axiosInstance(params);
    }
    return axiosInstance;
}
function resetAxiosInstance() {
    axiosInstance = null;
}

module.exports = {
    setAuthToken,
    setCSRFToken,
    getCSRFToken,
    setClientId,
    setBaseURL,
    setSocketURL,
    getSocketURL,
    getHeaders,
    setOptions,
    getAxiosInstance,
};
